module.exports = __webpack_public_path__ + "static/media/PGL01@m.7e153ef3.jpg";